import axios from 'axios';

import routes from 'app/routes';

export default {
  load: (dispatch, memberId) => {
    axios
      .get(routes.api.members.programs, { params: { student_id: memberId } })
      .then((resp) => {
        dispatch({ type: 'LOAD', programs: resp.data.data });
      });
  },
  remove: (dispatch, programId) => {
    axios
      .patch(routes.api.programs.unassign(programId))
      .then(() => {
        dispatch({ type: 'DELETE', id: programId });
      });
  },
};
